import { useAppContext } from "./useAppContext";

export const useAppState = () => {
  const { state } = useAppContext();
  return state;
};
